module.exports = __webpack_public_path__ + "img/logo_small.687564e3.png";